import React, { useEffect } from 'react';
import { Box, Drawer, Typography, Button } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { Browser } from '@capacitor/browser';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Importer le hook i18n

const ManageSubscription = ({ isOpen, onClose }) => {
  const { t } = useTranslation(); // Hook pour les traductions
  const { currentUser, refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAppStateChange = (state) => {
      if (state.isActive) {
        refreshUser();
      }
    };

    App.addListener('appStateChange', handleAppStateChange);

    return () => {
      App.removeAllListeners();
    };
  }, [refreshUser]);

  const handleManageSubscription = async () => {
    const info = await Device.getInfo();
    let url;
    
    if (info.platform === 'ios') {
      url = 'https://apps.apple.com/account/subscriptions';
    } else if (info.platform === 'android') {
      url = 'https://play.google.com/store/account/subscriptions';
    }

    if (url) {
      await Browser.open({ url });
    }
  };

  const handleStartTrial = () => {
    navigate('/subscribe');
  };

  return (
    <Drawer anchor="bottom" open={isOpen} onClose={onClose}>
      <Box sx={{ width: '100%', p: 3, pt: 4, pb: 5 }}>
        {currentUser ? (
          !currentUser.subscriptionStartDate ? (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" sx={{ mb: 2 }} gutterBottom>
                {t('start_free_trial')}
              </Typography>
              <Button variant="contained" color="primary" onClick={handleStartTrial}>
                {t('let_s_go')}
              </Button>
            </Box>
          ) : currentUser.subscriptionStatus === 'active' ? (
            <Box>
              <Typography variant="h6" sx={{ mb: 0 }} gutterBottom>
                {t('my_duo_subscription')}
              </Typography>
              <Typography sx={{ mt: 1.5 }} variant="body1">
                <strong>{t('status')}:</strong> {t('active')}
              </Typography>
              <Typography variant="body1">
                <strong>{t('start_date')}:</strong> {new Date(currentUser.subscriptionStartDate).toLocaleDateString()}
              </Typography>
              <Button variant="contained" color="primary" onClick={handleManageSubscription} sx={{ mt: 2 }}>
                {t('manage_subscription')}
              </Button>
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h6" sx={{ mb: 2 }} gutterBottom>
                {t('subscription_cancelled')}
              </Typography>
              <Button variant="contained" color="primary" onClick={handleStartTrial}>
                {t('renew')}
              </Button>
            </Box>
          )
        ) : (
          <Typography variant="body1">{t('loading')}</Typography>
        )}
      </Box>
    </Drawer>
  );
};

export default ManageSubscription;
